import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import React, { useEffect, useState, useContext } from "react";
import { MyContext } from "../../MyContext";
import DashboardCredentials from "./DashboardCredentials";
import { useSession } from "../session/Context";
import { useNavigate } from "react-router-dom";

let serverUrl = window.location.origin;

interface DashboardProps {
  onDetails: (activeCredential: any) => void;
}

const Dashboard = (props: DashboardProps) => {
  const { brand } = useSession();

  const notifyError = (err: any) => toast.error(err, { theme: "colored" });
  const notifySuccess = (text: any) =>
    toast.success(text, { theme: "colored" });
  
  const [credentials, setCredentials] = useState([]);
  const [issuances, setIssuances] = useState<any>({});

  const navigate = useNavigate();

  const { onPage, setOnPage } = useContext(MyContext)!;

  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
  }, []);

  useEffect(() => {
    // Fetch all credentials for this user
    //GET http://localhost:8000/api/v1/schemas?type=list
    var url =
      serverUrl +
      "/api/v1/brand" +
      (brand == "" ? "/root" : "/" + brand) +
      "/metadata?type=credentials&list=everything";

    fetch(url, {
      method: "POST",
      headers: {
        accept: "application.json",
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        // check for error response

        if (!response.ok) {
          const error = await response.text();
          return Promise.reject(error);
        } else {
          const data1 = await response.text();
          const credential = JSON.parse(data1);

          if (credential.success) {
            setCredentials(credential.response);
          } else {
            throw credential.error;
          }
        }
      })
      .catch((error) => {
        console.error("Error in API Issue: ", error);
        notifyError("Error displaying credentials: " + error);
      });

    fetch(
      "/api/v1/brand" +
        (brand == "" ? "/root" : "/" + brand) +
        "/metadata?type=issuances"
    ).then(async (response) => {
      if (!response.ok) {
        const error = await response.text();
        return Promise.reject(error);
      } else {
        const data1 = await response.text();
        const credential = JSON.parse(data1);

        if (credential.success) {
          setIssuances(credential.response);
        } else {
          throw credential.error;
        }
      }
    });
  }, []);

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Issued Credentials</h2>
        </div>
      </div>

      <div className="col-content">
        <div className="notifications-container">
          <div className="cards cards-3">
            <div className="credentials-container">
              {Object.keys(issuances).length !== 0 &&
                Object.values(issuances).map((val: any, index: number) => {
                  return (
                    <div
                      className="explorer-card-wrap"
                      key={val.email + "-" + index}
                    >
                      <div
                        className="explorer-card"
                        style={{
                          backgroundImage: `url(../../img/card_no-icon_grey.svg)`,
                        }}
                      >
                        <div className="container">
                          <p className="item subtitle">
                            {"Credential waiting to be accepted by " +
                              val.email +
                              " is not issued yet."}
                          </p>

                          <div className="item">
                            <p>Version: not issued</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              <br />

              {credentials.length === 0 &&
              Object.keys(issuances).length === 0 ? (
                <>
                  <div className="messages no-mobile-pro"></div>
                  <div>
                    <div className="sub_title">Issue your first credential</div>
                    <p>
                      Create a new verifiable credential using pre-built
                      templates.
                    </p>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        navigate("/create_credential");
                      }}
                    >
                      Issue credential
                    </button>
                  </div>
                </>
              ) : (
                credentials.map((val, index) => {
                  return (
                    <DashboardCredentials
                      credential={val}
                      key={index}
                      id={index + 1}
                      image="card_no-icon_pink.svg"
                      onDetails={(activeCredential: any) => {
                        props.onDetails(activeCredential);
                      }}
                    />
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
